export default {
  data(){
    return {
      hover: false,
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/component/close/close.js